import Vue from 'vue'
import VueRouter from "vue-router";

// 引入组件
import home from "@/page/Home.vue";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
	{
		path:"/",
		component: home
	},
	{path:'*',redirect:'/'} //这个路由的目的是如果在用户输入的路由在上面的路由都没有找到，就默认跳到根目录下
]

var router =  new VueRouter({
    routes:routes //,
	//mode:"history" //去掉#
})
export default router;
